module.exports = __webpack_public_path__ + "static/img/img19.1a63b7cd.png";